import {createApp} from 'vue'
import HighchartGraph from './HighchartGraph'
import handleComponentProps from '../../../../../Frontend/src/foundation/js/utils/handleComponentProps'

const el = '.nyk-component--highchart-graph'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((HighchartGraphDOM) => {
            const props = handleComponentProps(HighchartGraph, HighchartGraphDOM)
            const component = createApp(HighchartGraph, props).use(Store)
            component.mount(HighchartGraphDOM)
        })
    }
}